const DB_API_KEY = import.meta.env.VITE_DB_API_KEY;
const PBI_API_KEY = import.meta.env.VITE_PBI_API_KEY;
const ENTRA_API_KEY = import.meta.env.VITE_ENTRA_API_KEY;
const EMBED_API_KEY = import.meta.env.VITE_EMBED_API_KEY;

/**
 * API types for different Function Apps
 */
export const API_TYPES = {
  DATABASE: 'database',
  PBI: 'pbi',
  ENTRA: 'entra',
  EMBED: 'embed'
};

/**
 * Get the appropriate API key based on API type
 * @param {string} apiType - The type of API (use API_TYPES constants)
 * @returns {string|null} The API key or null if not configured
 */
const getApiKey = (apiType) => {
  switch (apiType) {
    case API_TYPES.DATABASE:
      return DB_API_KEY;
    case API_TYPES.PBI:
      return PBI_API_KEY;
    case API_TYPES.ENTRA:
      return ENTRA_API_KEY;
    case API_TYPES.EMBED:
      return EMBED_API_KEY;
    default:
      return null;
  }
};

/**
 * Get headers for API requests, including authorization token and Function App API key
 * @param {string} token - The bearer token for authorization
 * @param {string} apiType - The type of API (use API_TYPES constants)
 * @returns {Object} Headers object for fetch requests
 */
export const getApiHeaders = (token, apiType = null) => {
  const headers = {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
  
  // Add Function App API key if configured (for production)
  const apiKey = getApiKey(apiType);
  if (apiKey) {
    headers['x-functions-key'] = apiKey;
  }
  
  return headers;
};

/**
 * Get headers for API requests without Content-Type (e.g., for FormData)
 * @param {string} token - The bearer token for authorization
 * @param {string} apiType - The type of API (use API_TYPES constants)
 * @returns {Object} Headers object for fetch requests
 */
export const getApiHeadersWithoutContentType = (token, apiType = null) => {
  const headers = {
    'Authorization': `Bearer ${token}`
  };
  
  // Add Function App API key if configured (for production)
  const apiKey = getApiKey(apiType);
  if (apiKey) {
    headers['x-functions-key'] = apiKey;
  }
  
  return headers;
};